import { clsx } from 'clsx'
import { Heading, Subheading } from './text'

interface SectionHeaderProps {
  subheading?: string
  heading: string
  description?: string
  className?: string
  headingClassName?: string
}

export function SectionHeader({
  subheading,
  heading,
  description,
  className,
  headingClassName,
}: SectionHeaderProps) {
  return (
    <div className={clsx('text-center', className)}>
      {subheading && <Subheading className="mb-2">{subheading}</Subheading>}
      <Heading as="h2" className={clsx('mb-4', headingClassName)}>
        {heading}
      </Heading>
      {description && (
        <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-600">
          {description}
        </p>
      )}
    </div>
  )
}

